module.exports = __webpack_public_path__ + "static/media/ba.726a63bd.svg";